import { motion } from "framer-motion";

const LOGO_BADGES = [
  {
    img: "/logos/google-rating.png",
    alt: "Google Reviews rating 4.6 stars",
    title: "4.6 on Google",
    sub: "Rated by our visitors",
    dark: false,
    testid: "badge-google-rating",
  },
  {
    img: "/logos/tripadvisor-tc.png",
    alt: "Tripadvisor Travellers' Choice Awards 2026 — Top 10% worldwide",
    title: "Tripadvisor 2026",
    sub: "Travellers' Choice",
    dark: true,
    testid: "badge-tripadvisor",
  },
  {
    img: "/logos/capetown-tourism.jpg",
    alt: "Cape Town Tourism member",
    title: "Cape Town Tourism",
    sub: "Official tourism member",
    dark: false,
    testid: "badge-cape-town-tourism",
  },
  {
    img: "/logos/liquor-licence.png",
    alt: "Now with liquor licence",
    title: "Licensed Bar",
    sub: "Official liquor licence on site",
    dark: false,
    testid: "badge-liquor-license",
  },
  {
    img: "/logos/wifi-free.png",
    alt: "Free Wi-Fi on site",
    title: "Free Wi-Fi on site!",
    sub: "Awesome — and it's fast",
    dark: false,
    testid: "badge-free-wifi",
  },
  {
    img: "/logos/powered-by-solar.png",
    alt: "Powered by solar",
    title: "Powered by Solar",
    sub: "The park runs on sunshine",
    dark: false,
    testid: "badge-solar",
  },
  {
    img: "/logos/loadshedding-free.png",
    alt: "Loadshedding free",
    title: "Loadshedding-Free",
    sub: "The fun never stops",
    dark: false,
    testid: "badge-loadshedding-free",
  },
];

export default function TrustBadges() {
  return (
    <section id="badges" className="mx-auto max-w-7xl px-4 py-24 sm:px-6" data-testid="badges-section">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7 }}
      >
        <p className="eyebrow">Why families choose us</p>
        <h2 className="mt-3 max-w-2xl text-4xl leading-tight text-[#c87700] drop-shadow-[0_1px_0_rgba(122,86,0,0.6)] sm:text-5xl" style={{ fontFamily: '"Goodgirl", "Outfit", sans-serif' }}>THE PARK WITH THE PROOF</h2>
      </motion.div>

      <div
        className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 lg:grid lg:snap-none lg:grid-cols-3 lg:overflow-visible lg:pb-0 xl:grid-cols-4"
        data-testid="badges-track"
      >
        {LOGO_BADGES.map((b, i) => (
          <motion.div
            key={b.title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.55, delay: (i % 4) * 0.06 }}
            className={`flex h-full w-[72vw] max-w-[300px] shrink-0 snap-center flex-col items-center justify-center gap-3 rounded-3xl border border-[#241c0d]/12 p-6 shadow-[0_10px_30px_rgba(36,28,13,0.08)] transition-all hover:-translate-y-1 sm:w-[300px] lg:w-auto lg:max-w-none lg:shrink ${b.dark ? "bg-[#0a0a0b]" : "bg-white"}`}
            data-testid={b.testid}
          >
            <img src={b.img} alt={b.alt} loading="lazy" className="max-h-32 w-auto max-w-full object-contain" />
            <div className="text-center">
              <p className={`text-sm font-extrabold ${b.dark ? "text-[#faf5ea]" : "text-[#0a0a0b]"}`}>{b.title}</p>
              <p className={`text-xs ${b.dark ? "text-[#b9b4a6]" : "text-[#0a0a0b]/60"}`}>{b.sub}</p>
            </div>
          </motion.div>
        ))}
      </div>
      <p className="mt-4 text-center text-xs font-extrabold uppercase tracking-widest text-[#8a7b5e] lg:hidden" data-testid="badges-swipe-hint">
        Swipe for more badges →
      </p>
    </section>
  );
}
